import modalImage from '../../templates/slidePreview.html';
import modalImageUpload from '../../templates/slideUpload.html';
import edit_button from '../edit_button.html';
import cdn_drag_drop from "../cdn_drag_and_drop/cdn_drag_and_drop.html";

export default function (nga, admin) {
  const ads = admin.getEntity('appadsLite');
  ads.listView()
    .title('<h4>App Ads <i class="fa fa-angle-right" aria-hidden="true"></i> List</h4>')
    .batchActions([])
    .fields([
      nga.field('title', 'string')
        .label('Title'),
      nga.field('enabled', 'boolean')
        .label('Enabled'),
      nga.field('image_url', 'file')
        .template(modalImage)
        .label('Image'),
    ])
    .listActions(['edit', 'delete'])
    .exportFields([
      ads.listView().fields(),
    ]);

  ads.deletionView()
    .title('<h4>App Ads <i class="fa fa-angle-right" aria-hidden="true"></i> Remove <span style ="color:red;"> {{ entry.values.title }} </span></h4>')
    .actions(['<ma-back-button entry="entry" entity="entity"></ma-back-button>'])


  ads.creationView()
    .title('<h4>App Ads <i class="fa fa-angle-right" aria-hidden="true"></i> Create Ad </h4>')
    .fields([
      nga.field('title', 'string')
        .attributes({placeholder: 'Ad title'})
        .validation({required: true})
        .label('Title'),
      nga.field('enabled', 'boolean')
        .attributes({placeholder: 'Enabled'})
        .validation({required: true})
        .label('Is Enabled'),
      nga.field('image_url', 'file')
        .uploadInformation({'url': '/file-upload/single-file/app_ads_lite/image_url', 'apifilename': 'result', 'accept': 'image/webp,image/jpeg,image/png'})
        .template(modalImageUpload)
        .validation({
          validator: function (value) {
            if (value == null) {
              throw new Error('Please choose ad image');
            } else {
              var icon_url = document.getElementById('image_url');
              if (icon_url.value.length > 0) {
                if (icon_url.files[0].size > 5242880) {
                  throw new Error('Your Ad Image is too big. Maximum size is 5MB.');
                }
              }
            }
          }
        })
        .label('Image *'),
      nga.field('template')
        .label('')
        .template(edit_button),
    ]);

  ads.editionView()
    .title('<h4>App Ads <i class="fa fa-angle-right" aria-hidden="true"></i> Edit: {{ entry.values.title }}</h4>')
    .actions(['list'])
    .fields([
      ads.creationView().fields(),
      nga.field("", "template").label("").template(cdn_drag_drop),
    ]);

  return ads;

}



// WEBPACK FOOTER //
// ./js/appAdsLite/config.js